import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import * as serviceWorker from './serviceWorker';
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
          <App />
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
serviceWorker.register();
